import safeWindow from "common/utils/safeWindow";
import { useEffect, useState } from "react";

const useWindowSize = (): number[] => {
  const [hw, setHw] = useState(() => {
    const window = safeWindow();
    return [window.innerHeight, window.innerWidth];
  });

  useEffect(() => {
    const updateHw = () => setHw([window.innerHeight, window.innerWidth]);

    window.addEventListener("resize", updateHw);
    updateHw();

    return () => window.removeEventListener("resize", updateHw);
  }, []);

  return hw;
};

export default useWindowSize;
